var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@hn-ui/tooltips';
import { BlueButton, LightBlueButton, TextButton } from '@hn-ui/buttons';
import { Edit, Add, Print, Delete, Up, Down, Repeat } from '@hn-ui/icons';
import { styled } from 'styled-components';
import { PdfButtonWithTooltip } from '../PdfButtonWithTooltip';
var StyledTextButton = styled(TextButton).withConfig({ displayName: "StyledTextButton", componentId: "sc-1awt14u" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n\n  svg {\n    margin-right: 4px;\n  }\n"], ["\n  padding: 0;\n\n  svg {\n    margin-right: 4px;\n  }\n"])));
var StyledRedTextButton = styled(StyledTextButton).withConfig({ displayName: "StyledRedTextButton", componentId: "sc-6j3sf5" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.red50;
});
var ButtonContainer = styled.div.withConfig({ displayName: "ButtonContainer", componentId: "sc-1xpnps" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var BlueEditIcon = function () { return _jsx(Edit, { size: 16 }, void 0); };
var GrayEditIcon = function () { return _jsx(Edit, { size: 16, color: 'black70' }, void 0); };
var BluePrintIcon = function () { return _jsx(Print, { size: 16 }, void 0); };
var RedDeleteIcon = function () { return _jsx(Delete, { size: 16, color: 'red50' }, void 0); };
var GrayDeleteIcon = function () { return _jsx(Delete, { size: 16, color: 'black70' }, void 0); };
var WhiteAddIcon = function () { return _jsx(Add, { size: 16, color: 'black100' }, void 0); };
var UpIcon = function () { return _jsx(Up, { size: 16 }, void 0); };
var DownIcon = function () { return _jsx(Down, { size: 16 }, void 0); };
var BlueRecoverIcon = function () { return _jsx(Repeat, { size: 16 }, void 0); };
var EditButton = function (_a) {
    var disabled = _a.disabled, rest = __rest(_a, ["disabled"]);
    return (_jsx(StyledTextButton, __assign({ fit: true, LeftIcon: disabled ? GrayEditIcon : BlueEditIcon, disabled: disabled }, rest, { children: "Edit" }), void 0));
};
var PrintButton = function (_a) {
    var disabled = _a.disabled, url = _a.url, rest = __rest(_a, ["disabled", "url"]);
    return (_jsx(PdfButtonWithTooltip, __assign({ variant: 'text', colorScheme: 'accent', size: 'm', fit: true, LeftIcon: BluePrintIcon, disabled: disabled, apiUrl: url }, rest, { children: "Print" }), void 0));
};
var DeleteButton = function (_a) {
    var disabled = _a.disabled, rest = __rest(_a, ["disabled"]);
    return (_jsx(StyledRedTextButton, __assign({ fit: true, LeftIcon: disabled ? GrayDeleteIcon : RedDeleteIcon, disabled: disabled }, rest, { children: "Delete" }), void 0));
};
var DeleteButtonWithTooltip = function (_a) {
    var tooltipText = _a.tooltipText, rest = __rest(_a, ["tooltipText"]);
    return (_jsx(Tooltip, __assign({ content: tooltipText, maxWidth: 386 }, { children: _jsx(ButtonContainer, { children: _jsx(DeleteButton, __assign({ disabled: true }, rest), void 0) }, void 0) }), void 0));
};
var ConfirmButton = function (_a) {
    var title = _a.title, rest = __rest(_a, ["title"]);
    return (_jsx(BlueButton, __assign({ fit: true, size: 'small' }, rest, { children: title }), void 0));
};
var CancelButton = function (_a) {
    var title = _a.title, rest = __rest(_a, ["title"]);
    return (_jsx(LightBlueButton, __assign({ fit: true, size: 'small' }, rest, { children: title }), void 0));
};
var DownloadButton = function (_a) {
    var url = _a.url, rest = __rest(_a, ["url"]);
    return (_jsx(PdfButtonWithTooltip, __assign({ size: 's', variant: 'secondary', colorScheme: 'accent', fit: true, apiUrl: url }, rest, { children: "Download passwords" }), void 0));
};
var AddButton = function (_a) {
    var title = _a.title, rest = __rest(_a, ["title"]);
    return (_jsx(BlueButton, __assign({ fit: true, size: 'small', LeftIcon: WhiteAddIcon }, rest, { children: title }), void 0));
};
var AddButtonWithTooltip = function (_a) {
    var tooltipText = _a.tooltipText, rest = __rest(_a, ["tooltipText"]);
    return (_jsx(Tooltip, __assign({ content: tooltipText, maxWidth: 386 }, { children: _jsx(ButtonContainer, { children: _jsx(AddButton, __assign({ disabled: true }, rest), void 0) }, void 0) }), void 0));
};
var ViewDeletedStudentsButton = function (_a) {
    var isOpen = _a.isOpen, rest = __rest(_a, ["isOpen"]);
    return (_jsx(StyledTextButton, __assign({ fit: true, RightIcon: isOpen ? UpIcon : DownIcon }, rest, { children: "View deleted students" }), void 0));
};
var RecoverButton = function (_a) {
    var rest = __rest(_a, []);
    return (_jsx(StyledTextButton, __assign({ fit: true, LeftIcon: BlueRecoverIcon }, rest, { children: "Recover" }), void 0));
};
export { EditButton, PrintButton, DeleteButton, DeleteButtonWithTooltip, CancelButton, ConfirmButton, DownloadButton, AddButton, AddButtonWithTooltip, ViewDeletedStudentsButton, RecoverButton, };
var templateObject_1, templateObject_2, templateObject_3;
